import React from "react";
import { MenuItem } from "@mui/material";

const DSMenuItem = (props: React.ComponentProps<typeof MenuItem>) => {
  return <MenuItem {...props} />;
};

export default DSMenuItem;
